function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgChevronDown = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 22.12 16.88",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 946,
    y: 526,
    width: 28,
    height: 28,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(-949 -532)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M960.06,543.88a.69.69,0,0,0,.52-.24l5.34-5.45a.7.7,0,0,0,.2-.49.68.68,0,0,0-.69-.7.67.67,0,0,0-.5.21l-4.87,5-4.87-5a.65.65,0,0,0-.49-.21.69.69,0,0,0-.7.7.67.67,0,0,0,.21.49l5.33,5.45a.69.69,0,0,0,.52.24Z",
    style: {
      fill: "none",
      clipPath: "url(#clip-path)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-2)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.12,
    height: 16.88,
    style: {
      fill: "#0b2d46"
    }
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgChevronDown, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/chevronDown.fe0dc644.svg";
export { ForwardRef as ReactComponent };